var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "229px",
    height: "79px",
    viewBox: "0 0 229 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "brand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.245750315 39.6367415 0.245750315 39.6367415 63.6645851 0 63.6645851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30466583,0.245750315 C3.92635561,0.245750315 0.377301387,3.79520807 0.377301387,8.17311475 L0.377301387,8.17311475 C0.377301387,12.551425 3.92635561,16.1000757 8.30466583,16.1000757 L8.30466583,16.1000757 C17.0608827,16.1000757 24.1589912,23.1989912 24.1589912,31.9552081 L24.1589912,31.9552081 C24.1589912,40.7118285 17.0608827,47.8095334 8.30466583,47.8095334 L8.30466583,47.8095334 C12.6825725,47.8095334 16.2320303,51.3589912 16.2320303,55.7373014 L16.2320303,55.7373014 C16.2320303,60.1156116 12.6825725,63.6646658 8.30466583,63.6646658 L8.30466583,63.6646658 C25.8170996,63.6646658 40.0141236,49.4680454 40.0141236,31.9552081 L40.0141236,31.9552081 C40.0141236,14.4423707 25.8170996,0.245750315 8.30466583,0.245750315 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.56986511e-05%",
    y1: "49.9999388%",
    x2: "99.9997241%",
    y2: "49.9999388%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26CF1D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F712",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WelcomeCSD",
    transform: "translate(-397.000000, -158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brand",
    transform: "translate(397.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#536474",
    points: "69.3734174 61.5917276 81.5301892 61.5917276 81.5301892 1.66416141 69.3734174 1.66416141"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.350648,18.7859773 L116.458088,68.4400504 C114.061115,75.0321311 110.550799,78.2849937 103.017685,78.2849937 L90.2612661,78.2849937 L90.2612661,68.6111475 L101.390648,68.6111475 C104.472414,68.6111475 105.671304,67.4978058 106.955339,63.816797 L107.72568,61.5917276 L87.0084035,18.7859773 L100.192565,18.7859773 L107.297533,35.2230013 C109.780459,40.8736444 110.037105,45.4105422 110.122653,51.1471375 L114.660358,51.1471375 C114.745907,43.6128121 114.831455,40.1029004 116.629589,34.4526608 L121.680182,18.7859773 L134.350648,18.7859773 Z",
    id: "Fill-2",
    fill: "#536474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.282784,18.7859773 L152.240666,18.7859773 C152.155117,21.6110971 150.356984,25.292913 148.046366,28.6313241 L153.354008,28.6313241 C155.322835,22.5529382 159.603491,17.501942 166.452217,17.501942 C175.869417,17.501942 181.005962,23.751425 181.005962,33.254174 L181.005962,61.5917276 L168.84919,61.5917276 L168.84919,35.565599 C168.84919,29.9153594 166.195168,27.5187894 162.000868,27.5187894 C153.525508,27.5187894 153.439556,36.7644893 153.439556,41.3017907 L153.439556,61.5917276 L141.282784,61.5917276 L141.282784,18.7859773 Z",
    id: "Fill-4",
    fill: "#536474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.793826,50.5472888 L199.837256,47.037377 C200.008757,47.9796217 201.292792,54.2282976 209.596651,54.2282976 C213.877306,54.2282976 216.103586,52.3454224 216.103586,49.9488525 C216.103586,47.9796217 215.161342,46.266633 210.795541,45.410744 L204.717155,44.2122573 C195.728101,42.4145271 190.505604,39.4179067 190.505604,31.0284994 C190.505604,22.8957377 197.440282,17.5021438 208.911859,17.5021438 C219.613095,17.5021438 225.092237,23.0664313 226.975919,27.3474905 L216.959475,31.8843884 C215.67544,28.3744767 212.593675,25.8919546 208.312615,25.8919546 C204.20346,25.8919546 202.234633,27.6896847 202.234633,30.0007062 C202.234633,32.2269861 203.518265,33.3399243 208.141518,34.1958134 L214.048807,35.3087516 C222.09602,36.8498361 228.773246,40.5312484 228.773246,48.6644136 C228.773246,57.224918 221.411228,62.7900126 208.911859,62.7900126 C198.81027,62.7900126 190.591153,58.0816141 188.793826,50.5472888",
    id: "Fill-6",
    fill: "#536474"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.709377,16.1003985 C27.3310668,16.1003985 23.7820126,12.5513443 23.7820126,8.17303405 C23.7820126,3.79512736 27.3310668,0.245669609 31.709377,0.245669609 C14.1969433,0.245669609 -8.07061791e-05,14.4426936 -8.07061791e-05,31.9551274 C-8.07061791e-05,49.4679647 14.1969433,63.6645851 31.709377,63.6645851 C36.0876873,63.6645851 39.6367415,60.1155309 39.6367415,55.7372207 C39.6367415,51.3589105 36.0876873,47.8098562 31.709377,47.8098562 C22.9531602,47.8098562 15.8546482,40.7117478 15.8546482,31.9551274 C15.8546482,23.1989105 22.9531602,16.1003985 31.709377,16.1003985",
    id: "Fill-8",
    fill: "#00B0FF",
    mask: "url(#mask-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(23.404792, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30466583,0.245750315 C3.92635561,0.245750315 0.377301387,3.79520807 0.377301387,8.17311475 L0.377301387,8.17311475 C0.377301387,12.551425 3.92635561,16.1000757 8.30466583,16.1000757 L8.30466583,16.1000757 C17.0608827,16.1000757 24.1589912,23.1989912 24.1589912,31.9552081 L24.1589912,31.9552081 C24.1589912,40.7118285 17.0608827,47.8095334 8.30466583,47.8095334 L8.30466583,47.8095334 C12.6825725,47.8095334 16.2320303,51.3589912 16.2320303,55.7373014 L16.2320303,55.7373014 C16.2320303,60.1156116 12.6825725,63.6646658 8.30466583,63.6646658 L8.30466583,63.6646658 C25.8170996,63.6646658 40.0141236,49.4680454 40.0141236,31.9552081 L40.0141236,31.9552081 C40.0141236,14.4423707 25.8170996,0.245750315 8.30466583,0.245750315 Z",
    id: "Fill-12",
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.20a34530cd399b2bfaa269f94c80aeea.svg";
export { ForwardRef as ReactComponent };